<template>
<div class="location-product-recommends bg-white">
  <div class="container xl">
    <div class="columns is-multiline">
      
      <div class="column is-12">
        <h2 class="is-size-34px has-text-weight-normal text-center">We Think You Might Like This As Well</h2>
      </div>
      <div class="column is-12">
        <div class="recommend-product-wrapper">

          <swiper
            ref="recommendswiper"
            :slides-per-view="3"
            :scrollbar="{ draggable: true }"
            :loop="false"
            :navigation="nav"
            :slidesPerGroup="1"
            :freeMode="true"
            :spaceBetween="0"
            :breakpoints="breakpoints"
            :observer="true"
            :observeParents="true"
          >
          <swiper-slide
            v-bind:key="'rec_product_'+index" 
            v-for="(product, index) in recommendproducts" 
          >
            <div class="recommend-product-item">
              <weed-card 
                v-if="product.product_family == 'cannabis'" 
                :callback="goToLocationProductDetail" 
                :item="product" 
              ></weed-card>
              <accessory-card 
                v-else
                :callback="goToLocationProductDetail" 
                :item="product" 
              ></accessory-card>
            </div>
          </swiper-slide>
        </swiper>    

        <div class="budler-recommend-arrow arrow-prev" @click="prev">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#445232"/>
            <path d="M24 15H11.83L17.42 9.41L16 8L8 16L16 24L17.41 22.59L11.83 17H24V15Z" fill="white"/>
          </svg>
        </div>
        <div class="budler-recommend-arrow arrow-next" @click="next">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#445232"/>
          <path d="M16 8L14.59 9.41L20.17 15H8V17H20.17L14.59 22.59L16 24L24 16L16 8Z" fill="white"/>
          </svg>
        </div>

        </div>
      </div>

    </div>
  </div>
</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import Env from '@/env';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
SwiperCore.use([Navigation, Pagination])

export default {
  name: 'LocationProductRecommendations',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      breakpoints: { 
        3000: {
          slidesPerView: 3,
        }, 
        1920: {
          slidesPerView: 3,
        }, 
        1400: {
          slidesPerView: 3,
        }, 
        1024: {
          slidesPerView: 3,
        }, 
        991: {
          slidesPerView: 2,
        },
        820: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 1,
        },
        320: {
          slidesPerView: 1,
        }
      },
      nav: {
        nextEl: ".arrow-next",
        prevEl: ".arrow-prev",
      },
    };
  },
  
  props:{
    recommendproducts: {
      required: true,
      type: Array,
    },
  },

  computed: {
   
  },

  mounted() {

  },
  
  methods: {

    prev() {
      if(this.$refs.recommendswiper.$swiper){
        this.$refs.recommendswiper.$swiper.slidePrev()
      }
    },

    next() {
      if(this.$refs.recommendswiper.$swiper){
        this.$refs.recommendswiper.$swiper.slideNext()
      }
    },

    goToLocationProductDetail(item) {
      // Before push lets store the location details
      // this.va_setStoreProfileRecord({
      //   insertHistory: false,
      //   data: this.onLoadCategories,
      // });
      let queryToremove = ['verify_email', 'category', 'token', 'signup', 'source', 'signup_token'];
      if(this.vg_userId){
        queryToremove.push('referral_key')
      }
      this.$router.push({ 
        name: 'LocationProductDetail', 
        params: { store_slug: this.$route.params.store_slug, product_id: item.id },
        query: Helpers.refineQuery(queryToremove, this.$route.query)
      })
    },
  },
};
</script>
